import Alpine from "alpinejs";

const TYPES_OF_CREATION = {
  LINK: "link",
  WORK_ORDER: "work_order"
};

Alpine.data("homeController", (clientsPath, clientNewWorkOrderPath) => ({
  TYPES_OF_CREATION: TYPES_OF_CREATION,
  isCreateModalOpen: false,
  clients: [],
  selectedClient: null,
  searchQuery: "",
  typeOfCreation: TYPES_OF_CREATION.LINK,
  init() {
    this.getClients();

    this.$watch("searchQuery", value => {
      this.getClients(value);
    });

    this.$watch("selectedClient", () => {
      this.searchQuery = "";
    });

    this.$watch("isCreateModalOpen", value => {
      if (!value) {
        this.resetModalState();
      }
    });
  },
  isSelected(id) {
    if (!this.selectedClient) {
      return false;
    }
    return this.selectedClient.id === id;
  },
  selectClient(client) {
    this.selectedClient = client;
  },
  resetModalState() {
    this.selectClient(null);
    this.typeOfCreation = TYPES_OF_CREATION.LINK;
    this.searchQuery = "";
  },
  getClients(query = "") {
    fetch(`${clientsPath}?q[first_name_or_last_name_or_phone_cont]=${query}`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    })
      .then(response => response.json())
      .then(data => {
        this.clients = data;
      });
  },
  sendLink() {
    fetch(`${clientsPath}/${this.selectedClient.id}/schedule_request_url`)
      .then(response => {
        response.json().then(({ url }) => {
          window.open(url, "_blank").focus();
        });
      })
      .finally(() => {
        this.isCreateModalOpen = false;
      });
  },
  redirectToCreateWorkOrder() {
    window.location.href = `${clientNewWorkOrderPath.replace(":id", this.selectedClient.id)}`;
  },
  confirmAction() {
    if (!this.selectClient) return;

    if (this.typeOfCreation === TYPES_OF_CREATION.LINK) {
      this.sendLink(this.selectedClient.id);
    } else if (this.typeOfCreation === TYPES_OF_CREATION.WORK_ORDER) {
      this.redirectToCreateWorkOrder(this.selectedClient.id);
    }
  }
}));
